<app-session-timeout></app-session-timeout>
<app-spinner></app-spinner>
<header>
  <div class="primary-row">
    <div #headerContainerFirstRow class="container" [class.show-sidebar]="showSidebar">
      <div>
        <a #ontgov class="ontgov" tabindex="0" href="http://www.ontario.ca">
          <img src="assets/ontario-design-system/logos/ontario-logo--desktop.svg" alt="Government of Ontario">
        </a>
        <div class="grow"></div>
        <button (click)="changeLan()" class="btnLanguage" [attr.lang]="currentLang == 'en' ? 'fr' : 'en'">{{currentLang=='fr'? 'English':'Français'}}</button>
      </div>
    </div>
  </div>
  @if (site!='public') {
    <div class="secondary-row" [class.desktop-view]="site=='learner'">
      <div #headerContainerSecondRow class="container" [class.show-sidebar]="showSidebar">
        <div>
          @if (site=='tp') {
            <b>{{title}}</b>
          }
          @if (site=='learner') {
            <b>{{'MLITSDPreventionCMS.LearnerPortal' | translate}}</b>
          }
          @if (site=='login' || site == 'registration') {
            <b>&nbsp;</b>
          }
          @if (site=='employer') {
            <b>{{'MLITSDPreventionCMS.EmployerPortal' | translate}}</b>
          }
          <button [matMenuTriggerFor]="ctxMenu" (menuOpened)="menuOpen=true" (menuClosed)="menuOpen=false">
            <div class="user">
              {{userName}}
              <img [class.arrow-up]="menuOpen" src="assets/images/chevron-down-white-border.svg" alt="User Account">
            </div>
            <div class="menu">
              @if (!menuOpen) {
                <img src="assets/images/icon-menu.svg" alt="Menu">
              }
              @if (menuOpen) {
                <img src="assets/images/icon-close.svg" alt="Close">
              }
              Menu
            </div>
          </button>
          <mat-menu #ctxMenu="matMenu" xPosition="before" backdropClass="header-menu-backdrop">
            <div class="user">{{userName}}</div>
            <button mat-menu-item class="btn" (click)="signOut()">{{'General.SignOut' | translate}}</button>
            @if (showSwitchLink) {
              @if (site=='learner' || site=='tp' || site=='employer') {
                <hr class="divider" />
              }
              <!-- I am Learner -->
              @if (site=='learner') {
                <button mat-menu-item class="btn"
                  (click)="goTrainingPortal()">{{'MLITSDPreventionCMS.TrainingProviderPortal' | translate}}
                </button>
              }
              @if (site=='learner') {
                <button mat-menu-item class="btn"
                  (click)="goEmployerPortal()">{{'MLITSDPreventionCMS.EmployerPortal' | translate}}
                </button>
              }
              <!-- I am TP -->
              @if (site=='tp' && hasLearnerRole) {
                <button mat-menu-item class="btn"
                  [routerLink]="['/worker']">{{'MLITSDPreventionCMS.LearnerPortal' | translate}}
                </button>
              }
              @if (site=='tp') {
                <button mat-menu-item class="btn"
                  (click)="goEmployerPortal()">{{'MLITSDPreventionCMS.EmployerPortal' | translate}}
                </button>
              }
              <!-- I am Employer -->
              @if (site=='employer' && hasLearnerRole) {
                <button mat-menu-item class="btn"
                  [routerLink]="['/worker']">{{'MLITSDPreventionCMS.LearnerPortal' | translate}}
                </button>
              }
              @if (site=='employer') {
                <button mat-menu-item class="btn"
                  (click)="goTrainingPortal()">{{'MLITSDPreventionCMS.TrainingProviderPortal' | translate}}
                </button>
              }
            }
            @if (site=='tp' || site =='learner' || site =='employer') {
              <app-main-sidebar [contextMenu]="true"
                [site]="site">
              </app-main-sidebar>
            }
          </mat-menu>
        </div>
      </div>
    </div>
  }
</header>

<router-outlet></router-outlet>

@if (!userService.hideFooter) {
  <footer class='ontario-footer ontario-footer--expanded'>
    <div class='ontario-footer__expanded-top-section'>
      <div class='ontario-row container' [class.show-sidebar]="showSidebar">
        <div class="ontario-row">
          <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <h2 id="ministry-title" class="ontario-h4">
              {{'Footer.MinistryOfLabourTrainingAndSkillsDevelopment' | translate}}
            </h2>
            <p id="ministry-sub-title"
              [innerHTML]="'Footer.TheMinistryOfLabourTrainingAndSkillsDevelopmentAdvancesSafeTP' | translate">
            </p>
          </div>
          <div class="ontario-columns ontario-medium-5">
          </div>
        </div>
      </div>
    </div>
    <div class='ontario-row container' [class.show-sidebar]="showSidebar">
      <div class="ontario-row">
        <div
          class="ontario-columns ontario-small-12 ontario-large-6 ontario-medium-9 border-left-white ontario-margin-top-12-!">
          <div class="ontario-columns ontario-small-4 ontario-medium-4 ontario-large-4 footer-column">
            <a class="ontario-footer__link" target="_blank"
            href="{{'Footer.AboutOntarioLink' | translate}}">{{'Footer.AboutOntario' | translate}}</a>
          </div>
          <div class="ontario-columns ontario-small-3 ontario-medium-3 ontario-large-3 footer-column">
            <a class="ontario-footer__link" target="_blank" href="{{'Footer.NewsLink' | translate}}">{{'Footer.News' |
            translate}}</a>
          </div>
          <div class="ontario-columns ontario-small-5 ontario-medium-5 ontario-large-5 footer-column">
            <a class="ontario-footer__link ontario-footer-nowrap__link" target="_blank"
            href="{{'Footer.TermsOfUseLink' | translate}}">{{'Footer.TermsOfUse' | translate}}</a>
          </div>
        </div>
      </div>
      <div class="ontario-row">
        <div
          class="ontario-columns ontario-small-12 ontario-large-6 ontario-medium-9  border-left-white ontario-margin-top-12-!">
          <div class="ontario-columns ontario-small-4 ontario-medium-4 ontario-large-4 footer-column">
            <a class="ontario-footer__link" target="_blank"
            href="{{'Footer.AccessibilityLink' | translate}}">{{'Footer.Accessibility' | translate}}</a>
          </div>
          <div class="ontario-columns ontario-small-3 ontario-medium-3 ontario-large-3 footer-column">
            <a class="ontario-footer__link" target="_blank" href="{{'Footer.PrivacyLink' | translate}}">{{'Footer.Privacy'
            | translate}}</a>
          </div>
          <div class="ontario-columns ontario-small-5 ontario-medium-5 ontario-large-5 footer-column">
            <a class="ontario-footer__link" target="_blank"
            href="{{'Footer.ContactusLink' | translate}}">{{'Footer.ContactUs' | translate}}</a>
          </div>
        </div>
      </div>
      <div class="ontario-row">
        <div
          class="ontario-columns ontario-small-12 ontario-medium-8 ontario-large-5 footer-column ontario-margin-top-12-! ontario-margin-bottom-12-!">
          <a class="ontario-footer__link ontario-footer-nowrap__link" target="_blank"
            href="{{'Footer.KingsPrinterLink' | translate}}">
            {{translateService.instant('Footer.KingsPrinter').replace('{0}', year)}}
          </a>
        </div>
      </div>
    </div>
  </footer>
}
@if (showGoToTop) {
  <button (click)="ScrollToTop()" class="scroll-to-top-button">
    <img alt="" src="assets/images/arrow-up.svg" class="ng-star-inserted">
    <span class="back-to-top">{{'General.Top' | translate}}</span>
  </button>
}